import { HttpContextToken } from '@angular/common/http';

/**
 * Si es true, el spinnerInterceptor no muestra overlay/bloqueo de pantalla.
 * Usado por el chatbot para no bloquear la navegacion mientras Jen responde.
 */
export const SKIP_SPINNER = new HttpContextToken<boolean>(() => false);
